import Login from '@upright/ui/icons/img/streamline-light/business-products/data-files/data-file-bars-check.svg';
import { useOpenSubscriptionModal } from '@upright/ui/common/activities/company-subscription/subscription-modal/use-open-subscription-modal';
import { useNetImpactLensContext } from '@upright/ui/common/upright/core/impact-lenses/net-impact/common/use-net-impact-lens-context';
import styled from 'styled-components';
import { InternalInlineLink } from '../content/texts/inline-link';
import { NotAvailableModal } from './not-available-modal';
import { NotAvailableCommonElements } from '../../upright/iam/access/feature-access/not-available-content/types';
import { FeatureId } from '@upright/common/iam/access/feature-access/types';

interface Props {
  modalOpen: boolean;
  setModalOpen: (open: boolean) => void;
}

export const LoginToSuggestFixesModal = (props: Props) => {
  const openSubscriptionModal = useOpenSubscriptionModal();

  const lensContext = useNetImpactLensContext();
  const companyId = lensContext?.data?.entity?.id;
  const companyName = lensContext?.data?.entity?.name;

  const customContent: NotAvailableCommonElements = {
    icon: { svgElement: <Login /> },
    title: <>Help us improve this profile</>,
    ingress: (
      <IngressRoot>
        <p>
          If you work for this company, start by{' '}
          <ClaimCompanyLink
            onClick={() => {
              props.setModalOpen(false);
              openSubscriptionModal({ companyId, companyName });
            }}
          >
            claiming this company
          </ClaimCompanyLink>
          .
        </p>
        <p>
          Otherwise, <Link to={'/login'}>login</Link> or <Link to={'/signup'}>create a free account</Link> to suggest
          improvements.
        </p>
      </IngressRoot>
    ),
  };

  return (
    <NotAvailableModal
      {...{
        modalOpen: props.modalOpen,
        setModalOpen: props.setModalOpen,
        featureId: FeatureId.SUGGEST_FIXES,
        customContent,
      }}
    />
  );
};

const Link = styled(InternalInlineLink)`
  text-decoration: none;
  cursor: pointer;
  font-weight: bold;
`;

const ClaimCompanyLink = styled.span`
  text-decoration: none;
  cursor: pointer;
  font-weight: bold;
`;

const IngressRoot = styled.div`
  //display: flex;
  //flex-direction: column;
  //align-items: center;
  display: block;

  p + p {
    margin-top: 1em;
    line-height: 1.4;
  }
`;
